import Vue from 'vue'
import HsMyMenuStar from '../components/common/hs-my-menu-star.vue'
import '~/assets/scss/common.scss'

Vue.component('hs-my-menu-star', HsMyMenuStar)
